export default "__VITE_ASSET__d5e2ff5e__"